/* eslint-disable react/prop-types */
import React from 'react';
import MegaMenuLink from './MegaMenuLink';

const MegaMenuLinkBlock = ({ linkBlock }) => {
  const isLink = !!linkBlock?.url?.value;
  const title = linkBlock.title?.value || linkBlock.name;

  const icon = linkBlock.icon?.value?.url ? (
    <img src={linkBlock.icon.value.url} width={15} height={15} />
  ) : (
    <svg role="presentation" width={15} height={15} fill="#ffffff">
      <use xlinkHref="#chevron-right" />
    </svg>
  );

  return (
    <div className="mega-menu__link-block">
      {isLink ? (
        <div className="mega-menu__link-block-header">
          <a href={linkBlock.url.value} target={linkBlock.target?.value || "_self"}>
            {title}
          </a>
          {icon}
        </div>
      ) : (
        <span className="mega-menu__link-block-header">{title}</span>
      )}
      <div className="mega-menu__links">
        {linkBlock.linkList?.expandedValue?.map((link, index) => (
          <MegaMenuLink
            key={`${link.text}-${index}`}
            href={link.link?.value}
            description={link.description?.value}
            iconSrc={link.icon?.value?.url}
            target={link.target?.value}
            title={link.title?.value || link.name}
          />
        ))}
      </div>
    </div>
  );
};

export default MegaMenuLinkBlock;
